var parcelStatus = {
  ALL: -1, // All parcels
  BOOKED: 1, // Booked parcels (collected or not. Current event doesn't matter)
  COLLECTED: 2, // collected (Booked or not. Current event doesn't matter)
  NOT_BOOKED: 3, // Not booked (collected. Current event doesn't matter)
  NOT_COLLECTED: 4, // Not collected (Booked, but no scan)
  BOOKED_AND_COLLECTED: 5, // Booked and collected (Current event doesn't matter)
  IN_DESTINATION_COUNTRY: 7, // Has arrived in the destination country
  AT_PROVIDER: 6, // Currently at provider
  IN_TRANSIT: 8, // Currently in transit
  // HAS_BEEN_IN_TRANSIT: 9, //Is or has been in transit
  OUT_FOR_DELIVERY: 10, // Currently out for delivery
  // HAS_BEEN_OUT_FOR_DELIVEREY: 11, //Is or has been out for delivery
  DELIVERED: 12, // delivered (early, on time, late does't matter)
  EARLY: 13, // Delivered before open deadline
  ON_TIME: 14, // Delivererd before close deadline
  LATE: 15, // Delivered after close deadline (and without external delivay)
  EXTERNAL_DELAY: 16, // Delivered after close deadline and with an exteral delay
  MISSING_INFO: 17, // The parcel is missing weight, volume, delivery city or postal code.
  NOT_IN_DESTINATION_COUNTRY: 18, // The parcel has NOT arrived in the destination country yet.
  NOT_DELIVERED: 19, // Parcel is not delivered yet
  HAS_REPORTED_EXCEPTION: 20,
  DELIVERED_BUT_NOT_PICKED_UP_BY_ENGINEER: 21 // Delivered but not engineer pickup timestamp (normally only makes sense with PUDOs/Boxes)
}

export default {
  PARCEL_STATUS: parcelStatus,

  BOOKING_DATE_VALID_DAYS_IN_PAST: 90,
  BOOKING_DATE_VALID_DAYS_IN_FUTURE: 5,
  SCAN_VALID_DAYS_IN_FUTURE: 1,

  PARCEL_STATUS_OPTIONS: [
    {
      label: 'Booked',
      value: parcelStatus.BOOKED,
      selected: false
    },
    {
      label: 'Collected',
      value: parcelStatus.COLLECTED,
      selected: false
    },
    {
      label: 'Not booked',
      value: parcelStatus.NOT_BOOKED,
      selected: false
    },
    {
      label: 'Not collected',
      value: parcelStatus.NOT_COLLECTED,
      selected: false
    },
    {
      label: 'Booked & collected',
      value: parcelStatus.BOOKED_AND_COLLECTED,
      selected: false
    },
    {
      label: 'In precarriage',
      value: parcelStatus.NOT_IN_DESTINATION_COUNTRY,
      selected: false
    },
    {
      label: 'In destination country',
      value: parcelStatus.IN_DESTINATION_COUNTRY,
      selected: false
    },
    {
      label: 'At provider',
      value: parcelStatus.AT_PROVIDER,
      selected: false
    },
    {
      label: 'In transit',
      value: parcelStatus.IN_TRANSIT,
      selected: false
    },
    {
      label: 'Out for delivery',
      value: parcelStatus.OUT_FOR_DELIVERY,
      selected: false
    },
    {
      label: 'Delivered',
      value: parcelStatus.DELIVERED,
      selected: false
    },
    {
      label: 'Not delivered',
      value: parcelStatus.NOT_DELIVERED,
      selected: false
    },
    {
      label: 'Early',
      value: parcelStatus.EARLY,
      selected: false
    },
    {
      label: 'On time',
      value: parcelStatus.ON_TIME,
      selected: false
    },
    {
      label: 'Late',
      value: parcelStatus.LATE,
      selected: false
    },
    {
      label: 'External delay',
      value: parcelStatus.EXTERNAL_DELAY,
      selected: false
    },
    {
      label: 'Missing info',
      value: parcelStatus.MISSING_INFO,
      selected: false
    },
    {
      label: 'Reported Exception',
      value: parcelStatus.HAS_REPORTED_EXCEPTION,
      selected: false
    },
    {
      label: 'Delivered but not picked up by Engineer',
      value: parcelStatus.DELIVERED_BUT_NOT_PICKED_UP_BY_ENGINEER,
      selected: false
    }
  ],

  PARCEL_STATUS_EXPORT_PROOF_OPTIONS: [
    {
      label: 'Delivered',
      value: parcelStatus.DELIVERED,
      selected: false
    }
  ],

  PARCEL_LIST: {
    /**
     * Description: Booked parcels (collected or not. Current event doesn't matter)
     * Condition: Booked_Timestamp not null */
    PARCEL_STATUS_TEXT_BOOKED: 'Booked',
    /**
     * Description: collected (Booked or not. Current event doesn't matter)
     * Condition: Pickup_Timestamp not null */
    PARCEL_STATUS_TEXT_COLLECTED: 'Collected',
    /**
      * Description: Not booked (collected. Current event doesn't matter)
      * Condition: Booked_Timestamp null */
    PARCEL_STATUS_TEXT_NOT_BOOKED: 'Not Booked',
    /**
     * Description: Not collected (Booked, but no scan)
     * Condition: Current event is milestone Booked */
    PARCEL_STATUS_TEXT_NOT_COLLECTED: 'Not Collected',
    /**
     * Description: Booked and collected (Current event doesn't matter)
     * Condition: Booked_Timestamp not null && Current event != milestone Booked */
    PARCEL_STATUS_TEXT_BOOKED_AND_COLLECTED: 'Booked and Collected',
    /**
     * Description: Currently at provider
     * Condition: Current event is milestone Arrival at end forwarder  */
    PARCEL_STATUS_TEXT_AT_PROVIDER: 'At Provider',
    /**
     * Description: Currently in transit
     * Condition:  Current event is milestone In transit */
    PARCEL_STATUS_TEXT_IN_TRANSIT: 'In Transit',
    /**
     * Description: Currently out for delivery
     * Condition: Current event is milestone Out for delivery */
    PARCEL_STATUS_TEXT_OUT_FOR_DELIVERY: 'Out For Delivery',
    /**
     * Description: delivered (early, on time, late does't matter)
     * Condition: Delivery_Timestamp not null */
    PARCEL_STATUS_TEXT_DELIVERED: 'Delivered',
    /**
     * Description: not delivered */
    PARCEL_STATUS_TEXT_NOT_DELIVERED: 'Not delivered',
    /**
     * Description: Delivered before open deadline
     * Condition: Delivery_Timestamp not null && Delivery_Timestamp < Open_Deadline */
    PARCEL_STATUS_TEXT_EARLY: 'Early',
    /**
     * Description: Delivererd before close deadline
     * Condition: Delivery_Timestamp null || Close_Deadline is null || Delivery_Timestamp <= Close_Deadline || External_delay == true */
    PARCEL_STATUS_TEXT_ON_TIME: 'On Time',
    /**
     * Description: Delivered after close deadline (and without external delivay)
     * Condition: Delivery_Timestamp > Close_Deadline && External_delay == false  */
    PARCEL_STATUS_TEXT_LATE: 'Late',
    /**
     * Description: Delivered after close deadline and with an exteral delay
     * Condition: Delivery_Timestamp > Close_Deadline && External_delay == true */
    PARCEL_STATUS_TEXT_EXTERNAL_DELAY: 'External Delay',
    /**
     * Description: Pseudo Status if the Parcel is deleted
     * Condition:  */
    PARCEL_STATUS_TEXT_CANCELLED: 'Deleted',
    /**
     * Description: The parcel is missing weight, volume, delivery city or postal code.
     * Condition:  */
    PARCEL_STATUS_TEXT_MISSING_INFO: 'Missing Info',
    PARCEL_STATUS_TEXT_HAS_REPORTED_EXCEPTION: 'Reported Exception'
  },

  EXTERNAL_LINKS: {
    Daily_Cargo_Union_DB: 'https://ksda.ec.europa.eu/app/compliance/screen/home'
  },

  PARCEL_FIELD_KEYS: {
    PARCEL_ID: 'Parcel_ID',
    PROBLEM_TYPE_DESCRIPTION: 'Problem_Type_Description',
    CURRENT_STATUS_EVENT_INFO_ID: 'Current_Status_Event_Info_ID',
    CURRENT_STATUS_EVENT_NAME: 'Current_Status_Event_Name',
    CURRENT_STATUS_EVENT_TIMESTAMP: 'Current_Status_Event_Timestamp',
    CURRENT_STATUS_EVENT_USER_ID: 'Current_Status_Event_User_ID',
    CURRENT_STATUS_EVENT_USER_NAME: 'Current_Status_Event_User_Name',
    PARCEL_STATUS_BOOKED: 'Parcel_Status_BOOKED',
    PARCEL_STATUS_NOT_BOOKED: 'Parcel_Status_NOT_BOOKED',
    PARCEL_STATUS_COLLECTED: 'Parcel_Status_COLLECTED',
    PARCEL_STATUS_NOT_COLLECTED: 'Parcel_Status_NOT_COLLECTED',
    PARCEL_STATUS_BOOKED_AND_COLLECTED: 'Parcel_Status_BOOKED_AND_COLLECTED',
    PARCEL_STATUS_AT_PROVIDER: 'Parcel_Status_At_Provider',
    PARCEL_STATUS_IN_TRANSIT: 'Parcel_Status_IN_TRANSIT',
    PARCEL_STATUS_OUT_FOR_DELIVERY: 'Parcel_Status_OUT_FOR_DELIVERY',
    PARCEL_STATUS_DELIVERED: 'Parcel_Status_DELIVERED',
    PARCEL_STATUS_NOT_DELIVERED: 'Parcel_Status_NOT_DELIVERED',
    PARCEL_STATUS_ON_TIME: 'Parcel_Status_ON_TIME',
    PARCEL_STATUS_EXTERNAL_DELAY: 'Parcel_Status_EXTERNAL_DELAY',
    PARCEL_STATUS_LATE: 'Parcel_Status_LATE',
    PARCEL_STATUS_EARLY: 'Parcel_Status_EARLY',
    PARCEL_STATUS_HAS_REPORTED_EXCEPTION: 'Parcel_Status_HAS_REPORTED_EXCEPTION',
    BOOKED_TIMESTAMP: 'Booked_Timestamp',
    PICKUP_TIMESTAMP: 'Pickup_Timestamp',
    DELIVERY_TIMESTAMP: 'Delivery_Timestamp',
    ENGINEER_PICKUP: 'Engineer_Pickup',
    CUSTOMER_ID: 'Customer_ID',
    CUSTOMER_NAME: 'Customer_Name',
    COUNTRY_ID: 'Country_ID',
    COUNTRY_NAME: 'Country_Name',
    TAGS: 'Tags',
    PROVIDERS: 'Providers',
    PICKUP_ADDRESS_ID: 'Pickup_Address_ID',
    PICKUP_STREET_1: 'Pickup_Street_1',
    PICKUP_POSTAL_CODE: 'Pickup_Postal_Code',
    PICKUP_CITY: 'Pickup_City',
    PICKUP_COUNTRY_ID: 'Pickup_Country_ID',
    PICKUP_COUNTRY_NAME: 'Pickup_Country_Name',
    PICKUP_NAME_1: 'Pickup_Name_1',
    DELIVERY_ADDRESS_ID: 'Delivery_Address_ID',
    DELIVERY_STREET_1: 'Delivery_Street_1',
    DELIVERY_POSTAL_CODE: 'Delivery_Postal_Code',
    DELIVERY_CITY: 'Delivery_City',
    DELIVERY_COUNTRY_ID: 'Delivery_Country_ID',
    DELIVERY_COUNTRY_NAME: 'Delivery_Country_Name',
    DELIVERY_NAME_1: 'Delivery_Name_1',
    CONTACT_ID: 'Contact_ID',
    CONTACT_NAME: 'Contact_Name',
    BOOKED_PICKUP_DATE: 'Booked_Pickup_Date',
    IS_FORWARD: 'Is_Forward',
    WEIGHT: 'Weight',
    VOLUME: 'Volume',
    LENGTH: 'Length',
    WIDTH: 'Width',
    HEIGHT: 'Height',
    SERVICE_LEVEL_ID: 'Service_Level_ID',
    SERVICE_LEVEL_NAME: 'Service_Level_Name',
    XRAYED: 'XRayed',
    Last_Mile_Upgrade: 'Last_Mile_Upgrade',
    DANGEROUS_GOODS: 'Dangerous_Goods',
    OPEN_DEADLINE: 'Open_Deadline',
    CLOSE_DEADLINE: 'Close_Deadline',
    EXTERNAL_DELAY: 'External_Delay',
    CANCELLED: 'Cancelled',
    LATEST_NOTE: 'Latest_Note',
    SIGNED_BY_NAME: 'Signed_By_Name',
    CURRENT_PARCEL_STATUS: 'current_parcel_status',
    TRACKER_LINK: 'tracker_link',
    TRACKER_LINK_PROVIDER: 'provider_name',
    CONTACT_PHONE_NUMBER: 'Contact_Phone_Number',
    DANGEROUS_GOODS_UN_CODE: 'Dangerous_Goods_UN_Code',
    DANGEROUS_GOODS_PROPER_SHIPPING_NAME: 'Dangerous_Goods_Proper_Shipping_Name',
    DANGEROUS_GOODS_CLASS_OR_DIVISION: 'Dangerous_Goods_Class_Or_Division',
    DANGEROUS_GOODS_PACKING_GROUP: 'Dangerous_Goods_Packing_Group',
    DANGEROUS_GOODS_PACKING_INSTRUCTION: 'Dangerous_Goods_Packing_Instruction',
    DANGEROUS_GOODS_WEIGHT: 'Dangerous_Goods_Weight',
    DANGEROUS_GOODS_VOLUME: 'Dangerous_Goods_Volume'
  },
  SCAN_WITH_FILE_FIELDS: {
    EVENT_INFO_ID: 'Event_Info_ID',
    EVENT_INFO_NAME: 'Event_Info_Name',
    SCAN_TIMESTAMP: 'Timestamp',
    SCAN_NOTE: 'Note',
    SIGNED_BY: 'Signed_By'
  },
  PARCEL_FIELD_LABELS: {
    CUSTOMER: 'Customer',
    COUNTRY: 'Country',
    PROBLEM_TYPE_DESCRIPTION: 'Type of Problem',
    RESPONSIBLE_PROVIDER_NAME: 'Responsible Provider',
    RESPONSIBLE_CUSTOMER_NAME: 'Responsible Customer',
    PROBLEM_FREETEXT: 'Problem Freetext',
    NEW_ESTIMATED_DELIVERY_TIME: 'New estimated delivery time',
    CREATED_BY: 'Created by',
    CREATED_AT: 'Created at',
    DANGEROUS_GOODS: 'Dangerous Goods',
    XRAYED: 'X-Rayed',
    Last_Mile_Upgrade: 'Last Mile Upgrade',
    SERVICE_LEVEL: 'Service Level',
    OPEN_DEADLINE: 'Open Deadline',
    CLOSE_DEADLINE: 'Close Deadline',
    LENGTH: 'Length (cm)',
    WIDTH: 'Width (cm)',
    HEIGHT: 'Height (cm)',
    VOLUME: 'Volume (m3)',
    WEIGHT: 'Weight (kg)',
    BOOKED_PICKUP_DATE: 'Booked Pickup Date',
    PICKUP_TIME: 'Pickup Time',
    DELIVERY_TIME: 'Delivery Time',
    ENGINEER_PICKUP_TIME: 'Engineer Pickup Time',
    CURRENT_LOCATION: 'Current Location',
    SCANNED_AT: 'Scanned At',
    SCANNED_BY: 'Scanned By',
    FORWARDER_TRACKER: 'Forwarder Tracker',
    SIGNED_BY_NAME: 'Signed By Name',
    BOOKED_LENGTH: 'Booked Length (cm)',
    BOOKED_WIDTH: 'Booked Width (cm)',
    BOOKED_HEIGHT: 'Booked Height (cm)',
    BOOKED_VOLUME: 'Booked Volume (m3)',
    BOOKED_WEIGHT: 'Booked Weight (kg)',
    DANGEROUS_GOODS_UN_CODE: 'UN Code',
    DANGEROUS_GOODS_PROPER_SHIPPING_NAME: 'Proper Shipping Name',
    DANGEROUS_GOODS_CLASS_OR_DIVISION: 'Class Or Division',
    DANGEROUS_GOODS_PACKING_GROUP: 'Packing Group',
    DANGEROUS_GOODS_PACKING_INSTRUCTION: 'Packing Instruction',
    DANGEROUS_GOODS_WEIGHT: 'DGR Weight (kg)',
    DANGEROUS_GOODS_VOLUME: 'DGR Volume (m3)'
  },

  DASHBOARD: {
    CUSTOMER_GROUP_BY: 'Customer',
    COUNTRY_GROUP_BY: 'Country',
    CUSTOMER_NAME: 'Customer_Name',
    CUSTOMER_NAME_LABEL: 'Customer',
    COUNTRY_NAME: 'Country_Name',
    COUNTRY_NAME_LABEL: 'Country',
    FIELD_TOTAL: 'Total',
    FIELD_BOOKED: 'Booked',
    FIELD_NOT_BOOKED: 'Not_Booked',
    FIELD_COLLECTED: 'Collected',
    FIELD_NOT_COLLECTED: 'Not_Collected',
    FIELD_BOOKED_AND_COLLECTED: 'Booked_And_Collected',
    FIELD_IN_DESTINATION_COUNTRY: 'In_Destination_Country',
    FIELD_AT_PROVIDER: 'At_Provider',
    FIELD_IN_TRANSIT: 'In_Transit',
    FIELD_OUT_FOR_DELIVERY: 'Out_For_Delivery',
    FIELD_DELIVERED: 'Delivered',
    FIELD_NOT_DELIVERED: 'Not_Delivered',
    FIELD_ON_TIME: 'On_Time',
    FIELD_LATE: 'Late',
    FIELD_NOT_IN_DESTINATION_COUNTRY: 'Not_In_Destination_Country',
    FIELD_MISSING_INFO: 'Missing_Info',
    FIELD_EXTERNAL_DELAY: 'External_Delay',
    FIELD_EARLY: 'Early',
    FIELD_NET_PERFORMANCE: 'Net_Performance',
    FIELD_GROSS_PERFORMANCE: 'Gross_Performance',
    FIELD_WEIGHT: 'Weight',
    FIELD_COLLECTED_WEIGHT: 'Collected_Weight',
    FIELD_COLLECTED_VOLUME: 'Collected_Volume',
    FIELD_VOLUME: 'Volume',
    FIELD_HAS_REPORTED_EXCEPTION: 'Has_Reported_Exception'
  },

  EVENT_INFO_ID: {
    DELIVERED: 1,
    PARCEL_UPDATE: 318,
    PARCEL_UPDATE_DETAILS: 1287
  },

  //* ********** REFERENCE TYPE ID  ************/
  REFERENCE_TYPE_ID: {
    COUNTER_NUMBER: 1,
    SHIPMENT_REFERENCE: 2,
    ORDER_NUMBER: 3,
    FORWARDER_REFERENCE: 4,
    BARCODE: 5,
    DELIVERY_NOTE_NUMBER: 6,
    CMR_NUMBER: 7,
    PICKUP_REFERENCE: 8,
    STORAGE_NUMBER: 9,
    CUSTOMER_RETURN_REFERENCE: 10,
    CUSTOMS_DECLARATION_NUMBER: 11,
    RETURN_BARCODE: 12,
    FORWARDER_RETURN_REFERENCE: 13,
    SERVICE_ORDER: 15,
    CUSTOMER_NUMBER: 16,
    FORWARD_COUNTER_NUMBER: 17,
    RETURN_COUNTER_NUMBER: 18,
    AWB: 19,
    HAWB: 25,
    FORWARDER_BARCODE: 20,
    RETURN_PURCHASE_ORDER: 21,
    ACCOUNT_NUMBER: 22,
    FORWARDER_TRACKING_REFERENCE: 23,
    MATERIAL_NUMBER: 26
  },

  REFERENCE_TYPE_NAME: {
    PARCEL_ID: 'Parcel ID',
    COUNTER_NUMBER: 'Counter Number',
    SHIPMENT_REFERENCE: 'Shipment Reference',
    ORDER_NUMBER: 'Order Number',
    FORWARDER_REFERENCE: 'Forwarder Reference',
    BARCODE: 'Barcode',
    DELIVERY_NOTE_NUMBER: 'Delivery Note Number',
    CMR_NUMBER: 'CMR Number',
    PICKUP_REFERENCE: 'Pickup Reference',
    STORAGE_NUMBER: 'Storage Number',
    CUSTOMER_RETURN_REFERENCE: 'Customer Return Reference',
    CUSTOMS_DECLARATION_NUMBER: 'Customs Declaration Number',
    RETURN_BARCODE: 'Return Barcode',
    FORWARDER_RETURN_REFERENCE: 'Forwarder Return Reference',
    SERVICE_ORDER: 'Service Order',
    CUSTOMER_NUMBER: 'Customer Number',
    FORWARD_COUNTER_NUMBER: 'Forward Counter Number',
    RETURN_COUNTER_NUMBER: 'Return Counter Number',
    AWB: 'AWB',
    HAWB: 'HAWB',
    FORWARDER_BARCODE: 'Forwarder Barcode',
    RETURN_PURCHASE_ORDER: 'Return Purchase Order',
    ACCOUNT_NUMBER: 'Account Number',
    FORWARDER_TRACKING_REFERENCE: 'Forwarder Tracking Reference',
    MATERIAL_NUMBER: 'Material Number'
  },

  PERMISSION_TYPES: {
    ADDRESS: 'Address',
    DOCUMENT: 'Document',
    DASHBOARD: 'Dashboard',
    EVENT: 'Event',
    PARCEL: 'Parcel',
    PROBLEM_REPORT: 'Problem_Report',
    REFERENCE: 'Reference',
    USER: 'User',
    REPORT: 'Report',
    EXPORT_PROOF: 'Export_Proof',
    MONITORING: 'Monitoring',
    SPLIT_NEWS: 'Split_News',
    PUDO_EXPIRY: 'PUDO_Expiry',
    CONTACT: 'Contact',
    DROP_COST: 'Drop_Cost',
    CMR: 'CMR',
    ENGINEER: 'Engineer',
    MATCH_SCAN: 'Match_Scan',
    PROBLEM_REPORT_MEASURE: 'Problem_Report_Measure',
    PROVIDER: 'Provider',
    TAG: 'Tag',
    DEADLINE: 'Deadline',
    DAILY_CARGO: 'Daily_Cargo'
  },

  PERMISSION_VALUES: {
    CREATE: 'Create',
    VIEW: 'View',
    LIST: 'List',
    DELETE: 'Delete',
    UPDATE: 'Update',
    UPLOAD: 'Upload',
    SCAN: 'Scan',
    EARLY_COLUMN: 'Early_Column',
    GROSS_PERFORMANCE_COLUMN: 'Gross_Performance_Column',
    BOOK: 'Book',
    BOOK_CONSOLIDATED: 'Book_Consolidated',
    SHOW_UPDATE_EVENT: 'Show_Update_Event',
    BOOK_WITH_FILE: 'Book_With_File',
    UPDATE_WITH_FILE: 'Update_With_File',
    SCAN_WITH_FILE: 'Scan_With_File',
    BOOK_FORWARD: 'Book_Forward',
    BOOK_RETURN: 'Book_Return',
    BOOK_CONSOLIDATED_FORWARD: 'Book_Consolidated_Forward',
    BOOK_CONSOLIDATED_RETURN: 'Book_Consolidated_Return',
    GENERATE_COUNTER_NUMBER: 'Generate_Counter_Number',
    SIEMENS: 'Siemens',
    ADD_PROBLEM_REPORT_MEASURE: 'Add_Problem_Report_Measure',
    REACTIVATE: 'Reactivate'
  },

  defaultToastOptions: function () {
    return {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'center',
      mode: 'override',
      className: ['spl-success-toast']
    }
  },

  BUS_EVENTS: {
    OPEN_BOOK_SUCCESS_MODAL: 'openBookSuccessModal'
  },

  FLIGHT_ID: {
    FKB_JKG: 2,
    JKG_HEL: 13,
    JKG_OSL: 12,
    MHG_BLQ: 1,
    JKG_BLL: 14,
    MHG_LBG: 3
  },

  FILTER_NAMES: {
    TIMEFRAME: 'timeframe',
    CUSTOMER: 'customer',
    COUNTRY: 'country',
    PARCEL_STATUS: 'parcel status',
    SERVICE_LEVEL: 'service level',
    CURRENT_EVENT: 'current event',
    SHOW_FLOW: 'show flow',
    POSTAL_CODE: 'postal code'
  },

  BUS_KEYS: {
    BOOK_SUCCESS_MODAL_TYPE_PARCEL: 'parcel',
    BOOK_SUCCESS_MODAL_TYPE_CONSOLIDATED: 'consolidated'
  },

  PROVIDER_NAME: {
    RICO: 'TVS Rico',
    BYBOX: 'ByBox',
    JETPAK_SE: 'Jetpak SE'
  },

  PROVIDER_ID: {
    RICO: 101,
    BYBOX: 13,
    JETPAK_NO: 17,
    JETPAK_SE: 120
  },

  CUSTOMER_ID: {
    DHL_ROCHE: 64,
    FUJITSU: 4,
    FUJITSU_TMS: 1,
    SIEMENS_DIAGNOSTICS: 44,
    SIEMENS_HEALTHCARE: 2,
    SIEMENS_RICO: 115,
    AGILENT: 23,
    AGILENT_ERC: 31,
    DHL_SYSMEX: 66,
    CNH: 93,
    CNH_IVECO: 97,
    SAME_DEUTZ_FAHR: 61,
    SYSMEX: 105,
    SIEMENS_DOMESTIC: 111,
    GE_HEALTHCARE: 125
  },

  SERVICE_LEVEL_ID: {
    EXPRESS: 0,
    STANDARD: 1,
    EARLY_PICKUP: 2,
    LATE_PICKUP: 3,
    LOCAL: 4,
    HEAVY_WEIGHT: 5,
    EMERGENCY: 6,
    WEEKEND: 7,
    SAME_DAY: 10,
    PRE_TIME: 11,
    PRE_07: 34,
    PRE_08: 12,
    PRE_09: 13,
    PRE_12: 14,
    PUDO: 15,
    LOCKER_BOX: 16,
    IBOX: 17,
    LAST_MILE: 18,
    PICKUP: 19,
    PRE_10: 20,
    PRE_13: 21,
    HEAVY_WEIGHT_PARIS: 22,
    PUDO_LM2S: 23,
    PRE_11: 24,
    GEODIS_NET_EXPRESS_SPECIAL: 25,
    ASSISTED_FIT: 26,
    RENDEVOUZ: 27,
    SIEMENS_DELIVERY_BOX: 28,
    SATURDAY_DELIVERY: 9,
    SATURDAY_PRE_09: 35,
    SATURDAY_PRE_10: 29,
    SATURDAY_PRE_13: 30,
    VIRTUALBOX: 31,
    AIR_LINEHAUL: 32,
    CIBLEX_PRE_09: 36,
    CIBLEX_SATURDAY: 37,
    DIRECT_DELIVERY: 38,
    PUDO_LM2S_PRE_13: 39,
    GEODIS_FRANCE_EXPRESS: 40,
    ROAD_LINEHAUL: 41,
    CHRONOPOST_PARCEL_SHOP: 42,
    CHRONOPOST_LA_POSTE: 43,
    CHRONOPOST_LA_POSTE_SATURDAY: 44,
    CHRONOPOST_DEPOT: 45,
    CHRONOPOST_DEPOT_SATURDAY: 46,
    PRE_07_MED: 47,
    PRE_08_MED: 48,
    PRE_09_MED: 49,
    PRE_10_MED: 50,
    PRE_11_MED: 51,
    PRE_12_MED: 52,
    PRE_13_MED: 53,
    SATURDAY_PRE_09_MED: 54,
    SATURDAY_PRE_10_MED: 55,
    SATURDAY_PRE_13_MED: 56,
    STOCKONNECT: 57,
    PUDO_CIBLEX: 58,
    SITE_RETURN: 60
  },

  COUNTRY_ID: {
    UNKNOWN: 0,
    SWEDEN: 1,
    NORWAY: 2,
    DENMARK: 3,
    FINLAND: 4,
    GERMANY: 6,
    FAROES_ISLANDS: 8,
    FRANCE: 10,
    NETHERLANDS: 11,
    BELGIUM: 12,
    ITALY: 13,
    UK: 14,
    SPAIN: 15,
    ICELAND: 16,
    GREENLAND: 17,
    ESTONIA: 24,
    LATVIA: 25,
    LITHUANIA: 26,
    POLAND: 27,
    GREECE: 28,
    SWITZERLAND: 29,
    IRELAND: 30,
    PORTUGAL: 31,
    AUSTRIA: 32,
    ROMANIA: 36,
    RUSSIA: 43,
    CHINA: 44,
    CANARY_ISLANDS: 45,
    ANDORRA: 48,
    MONACO: 50,
    GUERNSEY: 220,
    ISLE_OF_MAN: 221,
    JERSERY: 222
  },

  ACTION_BAR_HEIGHT: 70,
  PARCEL_LIST_SUMMARY_HEIGHT: 70,
  ROUTING: 'Routing'

}
